<template>
  <v-container fluid>
    <alert-unsaved-changes v-if="unsavedChanges && edit"></alert-unsaved-changes>
    <v-form ref="contactForm">
      <v-row>
        <v-col cols="12">
          <h3 class="secondary300--text">{{ $t('public-contact') }}</h3>
        </v-col>
      </v-row>
      <div v-for="(publicContact, index) in patent.publicContacts" :key="index">
        <v-row class="mt-5" v-if="!publicContact.verified && edit">
          <v-col cols="12" id="verify-email" class="primary400--text pt-4 pb-4">
            <v-row>
              <v-col
                cols="12"
                xl="9"
                lg="9"
                md="9"
                sm="12"
                class="d-flex flex-row justify-left align-center"
              >
                <b>The user has not been verified.</b>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="3" sm="12" class="d-flex flex-row justify-end">
                <v-btn
                  depressed
                  rounded
                  @click="resendVerification(publicContact)"
                  outlined
                  class="primary200--text font-weight-bold"
                  style="background: white"
                >
                  {{ 'Resend Verification' }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="9" sm="9" md="4">
            <label>{{ $t('email') }}</label>
            <p class="label-info">
              Email of the patent's contact person or a generic email of the Provider to be
              displayed publicly at the portal.Email of the patent's contact person or a generic
              email of the Provider to be displayed publicly at the portal.
            </p>
            <v-text-field
              v-model.trim="publicContact.email"
              :placeholder="$t('email')"
              outlined
              type="email"
              class="required"
              :rules="emailRules()"
              clearable
            ></v-text-field>
          </v-col>
          <v-col class="mt-5" v-if="patent.publicContacts.length > 1">
            <v-btn fab small text @click="removePublicContact(index)">
              <v-icon>
                $vuetify.icons.trash
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Optional Contact -->
        <v-row v-if="edit">
          <v-col cols="12">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $t('optional-info') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-5">
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <label>First Name</label>
                      <p class="label-info">
                        First Name of the patent's contact person to be displayed publicly at the
                        Portal.
                      </p>
                      <v-text-field
                        v-model.trim="publicContact.firstname"
                        :placeholder="'First Name'"
                        outlined
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <label>Last Name</label>
                      <p class="label-info">
                        Last Name of the patent's contact person to be displayed publicly at the
                        Portal.
                      </p>
                      <v-text-field
                        v-model.trim="publicContact.lastname"
                        :placeholder="'Last Name'"
                        outlined
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <label>Phone</label>
                      <p class="label-info">
                        Telephone of the patent's contact person to be displayed publicly at the
                        Portal.
                      </p>
                      <v-text-field
                        v-model.trim="publicContact.phone"
                        :placeholder="'Phone'"
                        outlined
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <label>Position</label>
                      <p class="label-info">
                        Position of the patent's contact person to be displayed publicly at the
                        Portal.
                      </p>
                      <v-text-field
                        v-model.trim="publicContact.position"
                        :placeholder="'Position'"
                        outlined
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <label>Organisation</label>
                      <p class="label-info">
                        The organisation to which the patent's public contact person is affiliated.
                      </p>
                      <v-autocomplete
                        v-model="publicContact.organisation"
                        :items="organisations"
                        :item-value="'id'"
                        :item-text="'name'"
                        return-object
                        outlined
                        :placeholder="'Select Organisation'"
                        clearable
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </div>

      <v-row v-if="edit" class="mt-5">
        <v-col cols="4">
          <v-btn
            @click="addPublicContact"
            depressed
            rounded
            large
            color="primary200"
            class="white--text font-weight-bold"
          >
            <v-icon left>
              $vuetify.icons.plus
            </v-icon>
            <span class="text-decoration-underline text-transform-none font-weight-bold">
              Add a Public Contact
            </span>
          </v-btn>
        </v-col>
      </v-row>

      <!-- Buttons -->
      <v-row class="my-5" justify="end">
        <v-btn
          v-if="unsavedChanges && edit"
          @click="cancel"
          outlined
          class="black--text font-weight-bold mx-2"
          rounded
          x-large
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          v-if="unsavedChanges && edit"
          @click="updatePublicContactInfo"
          depressed
          rounded
          x-large
          color="primary200"
          class="white--text font-weight-bold"
        >
          {{ $t('update') }}
        </v-btn>
        <v-btn
          v-if="!unsavedChanges"
          depressed
          rounded
          x-large
          color="black"
          @click="back"
          outlined
          class="black--text font-weight-bold mx-2"
        >
          <v-icon color="black">$vuetify.icons.back</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn
          v-if="!unsavedChanges"
          v-show="showNextButton"
          depressed
          rounded
          x-large
          color="primary200"
          @click="next"
          class="white--text font-weight-bold"
          >{{ $t('next') }}
          <v-icon color="white">$vuetify.icons.next</v-icon>
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import AlertUnsavedChanges from '@/components/shared/helpers/AlertUnsavedChanges';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'PatentContactInfo',
  components: { AlertUnsavedChanges },
  mixins: [util],
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    published: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    patent: {
      publicContacts: [
        {
          email: '',
          verified: false,
          id: null,
          firstname: '',
          lastname: '',
          phone: '',
          position: '',
          organisation: {
            id: null,
            name: '',
          },
        },
      ],
    },
    organisations: [],
    showNextButton: true,
    unsavedChanges: false,
    status: false,
    dataLoaded: false,
    initialPatent: {},
    initialStatus: {},
  }),
  watch: {
    'patent.publicContacts': {
      deep: true,
      handler(newPublicContacts) {
        if (!this.dataLoaded) return;

        if (JSON.stringify(newPublicContacts) !== JSON.stringify(this.initialPatent)) {
          this.unsavedChanges = true;
        } else {
          this.unsavedChanges = false;
        }
      },
    },
    published: {
      deep: true,
      handler() {
        if (!this.dataLoaded) return;
        this.unsavedChanges = this.status !== this.published;
      },
    },
  },
  mounted() {
    if (this.edit) {
      this.getPatentContactInfo();
      this.axios
        .get('/api/v1/hosting-institutions/all')
        .then(res => (this.organisations = res.data));
    }
  },
  methods: {
    back() {
      this.$emit('tab', 2);
    },
    next() {
      this.isFormValid = this.$refs.contactForm.validate();
      if (this.isFormValid && !this.edit) {
        const email = this.patent.publicContacts.map(contact => ({
          email: contact.email,
        }));

        this.$emit('patentContactInfo', { publicContacts: email });
        this.showNextButton = false;
      }

      if (this.isFormValid && this.edit) {
        this.$emit('tab', 4);
      }
    },
    resendVerification(publicContact) {
      const id = publicContact.id;

      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/patent/resend-verification', { id })
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: 'Verification sent it successfully',
          });
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    removePublicContact(index) {
      this.patent.publicContacts.splice(index, 1);
    },
    addPublicContact() {
      this.patent.publicContacts.push({
        email: '',
        id: null,
        firstname: '',
        lastname: '',
        phone: '',
        position: '',
        organisation: {
          id: '',
          name: '',
        },
      });
    },
    getPatentContactInfo() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/patent/${id}`)
        .then(response => {
          console.log('Get Patent Contact Info', response.data);

          if (response.data.publicContacts) {
            this.patent.publicContacts = response.data.publicContacts.map(contact => ({
              email: contact.email,
              id: contact.id,
              verified: contact.verified,
              firstname: contact.firstname,
              lastname: contact.lastname,
              phone: contact.phone,
              position: contact.position,
              organisation: {
                id: contact.organisation ? contact.organisation.id : null,
                name: contact.organisation ? contact.organisation.name : '',
              },
            }));

            this.initialPatent = JSON.parse(JSON.stringify(this.patent.publicContacts));
          }

          this.status = response.data.published;
          this.initialStatus = {
            published: response.data.published,
          };
          this.$emit('status', this.initialStatus.published);

          this.dataLoaded = true;
        })
        .catch(error => {
          console.error('Error fetching patent data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    updatePublicContactInfo() {
      const id = this.$route.params.id;
      const patentUpdateData = {
        published: this.published,
        id: id,
        publicContacts: [...this.patent.publicContacts],
      };

      this.deleteEmptyProperties(patentUpdateData);

      this.isFormValid = this.$refs.contactForm.validate();
      if (this.isFormValid) {
        this.axios
          .put('api/v1/patent/contact-info', patentUpdateData)
          .then(response => {
            console.log('Patent info updated successfully:', response.data);
            EventBus.$emit('snackbar', {
              text: 'Patent Updated Successfully',
            });

            this.initialStatus = this.status;
            this.unsavedChanges = false;
            this.$emit('updatedChanges', true);

            this.getPatentContactInfo();
          })
          .catch(error => {
            console.error('Error updating patent info:', error);
          });
      }
    },
    cancel() {
      this.getPatentContactInfo();
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
  },
};
</script>
